<template>
  <aside class="sidebar" :class="{ open: isOpen }">
    <div class="sidebar-header">
      <img src="../../assets/logo_igreja.png" alt="El Shaday" class="sidebar-logo" />
      <span class="sidebar-brand">El Shaday</span>
    </div>

    <nav class="sidebar-nav">
      <router-link to="/" class="nav-item" exact-active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M13 9V3h8v6h-8ZM3 13V3h8v10H3Zm10 8V11h8v10h-8ZM3 21v-6h8v6H3Z"/></svg>
        <span>Dashboard</span>
      </router-link>
      <router-link to="/participants" class="nav-item" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.39 3.39 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.39 3.39 0 0 0 15 11a3.5 3.5 0 0 0 0-7Z"/></svg>
        <span>Participantes</span>
        <span class="badge" v-if="counters.total">{{ counters.total }}</span>
      </router-link>
      <router-link to="/check-in" class="nav-item" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4l4.25 4.25ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"/></svg>
        <span>Check-in</span>
        <span class="badge badge-warning" v-if="counters.pending">{{ counters.pending }}</span>
      </router-link>
      <router-link to="/confirmed" class="nav-item" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="m5.8 21l1.6-7L2 9.2l7.2-.6L12 2l2.8 6.6l7.2.6l-5.4 4.8l1.6 7L12 17.3L5.8 21Z"/></svg>
        <span>Confirmados</span>
        <span class="badge badge-success" v-if="counters.confirmed">{{ counters.confirmed }}</span>
      </router-link>
      <router-link to="/scanner" class="nav-item" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M3 11h8V3H3v8zm2-6h4v4H5V5zm8-2v8h8V3h-8zm6 6h-4V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm13-2h-2v3h-3v2h3v3h2v-3h3v-2h-3v-3zm-3 8v-3h-2v5h5v-2h-3zm6 0h-2v2h2v-2z"/></svg>
        <span>Scanner</span>
      </router-link>
    </nav>

    <div class="sidebar-footer">
      <div class="sidebar-user">
        <span class="user-name">{{ adminName }}</span>
      </div>
      <button class="logout-btn" @click="$emit('logout')">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M5 21q-.825 0-1.413-.588T3 19V5q0-.825.588-1.413T5 3h7v2H5v14h7v2H5Zm11-4l-1.375-1.45l2.55-2.55H9v-2h8.175l-2.55-2.55L16 7l5 5l-5 5Z"/></svg>
        <span>Sair</span>
      </button>
    </div>
  </aside>
</template>

<script>
export default {
  name: 'SidebarNav',
  props: {
    isOpen: { type: Boolean, default: false },
    adminName: { type: String, default: '' },
    counters: { type: Object, default: () => ({ total: 0, pending: 0, confirmed: 0 }) }
  },
  emits: ['logout']
}
</script>

<style scoped>
.sidebar {
  width: 250px;
  height: 100vh;
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-card);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 50;
  transition: transform 0.3s ease-in-out;
}
.sidebar-header {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: var(--spacing-base);
  border-bottom: 1px solid var(--color-bg-separator);
}
.sidebar-logo {
  width: 40px;
  height: 40px;
  border-radius: var(--radius-circle);
  object-fit: cover;
}
.sidebar-brand {
  font-size: var(--text-lg);
  font-weight: 700;
  color: var(--color-text-primary);
}
.sidebar-nav {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: var(--spacing-md) 0;
}
.nav-item {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  padding: 12px var(--spacing-base);
  color: var(--color-text-secondary);
  text-decoration: none;
  font-size: var(--text-base);
  font-weight: 500;
  transition: var(--transition-fast);
  border-left: 3px solid transparent;
}
.nav-item:hover {
  background: var(--color-bg-hover);
  color: var(--color-text-primary);
}
.nav-item.active {
  background: rgba(51, 102, 204, 0.08);
  color: var(--color-accent);
  border-left-color: var(--color-accent);
  font-weight: 600;
}
.nav-item svg {
  flex-shrink: 0;
}
.badge {
  margin-left: auto;
  background: var(--color-bg-body);
  color: var(--color-text-secondary);
  font-size: var(--text-xs);
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  min-width: 24px;
  text-align: center;
}
.badge-warning {
  background: #ead994;
  color: #856404;
}
.badge-success {
  background: #95eab8;
  color: #155724;
}
.sidebar-footer {
  padding: var(--spacing-base);
  border-top: 1px solid var(--color-bg-separator);
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}
.sidebar-user {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
}
.user-name {
  font-size: var(--text-sm);
  color: var(--color-text-muted);
  font-weight: 500;
}
.logout-btn {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  background: none;
  border: none;
  color: var(--color-text-muted);
  font-size: var(--text-sm);
  cursor: pointer;
  padding: var(--spacing-sm) 0;
  transition: var(--transition-fast);
}
.logout-btn:hover {
  color: var(--color-danger);
}

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
  }
  .sidebar.open {
    transform: translateX(0);
  }
}
</style>
